<template>
  <v-card class="dialog-card">
    <ModalHeader
      icon="mdi-account-circle"
      modalTitle="Your Account"
      @close="emit('close')" />
    <div>
      <Account />
    </div>
  </v-card>
</template>
<script setup>
import { defineAsyncComponent } from 'vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';

// Use dynamic import to avoid bundling Account component into main chunk
const Account = defineAsyncComponent(() => import('./Account.vue'));

const emit = defineEmits(['close']);
</script>
<style>
.mdi-account-circle {
  margin-right: 0px !important;
}
</style>
